export default __webpack_public_path__ + "static/media/DylanTarlowe.d9a1ab53.JPG";